module.exports = __webpack_public_path__ + "static/media/job-bg.7274469e.jpg";